import dayjs from "dayjs";

// Components
import { Typography, Card, CardContent, Stack, Avatar, Divider, IconButton } from "@mui/material";

// Icons
import PersonIcon from "@mui/icons-material/Person";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { useSelector } from "react-redux";


const AccountDetails = ({ user, openDeleteModal, openUpdateModal }) => {
  const server = useSelector((state) => state.server.serverType);
  console.log("🚀 ~ AccountDetails ~ user:", user);
  const createdAt = user?.created_at ? dayjs(user.created_at).format("DD/MM/YYYY à HH:MM") : "--";
  const lastLogin = user?.last_login ? dayjs(user.last_login).fromNow() : "--";

  const accountType =
    user?.roles?.length > 0 ? (user?.roles[0] === "ROLE_TRANSPORTEUR" ? "Transporteur" : "Éxpéditeur") : "--";

  const renderDetail = (icon, text, extra = null) => (
    <Typography sx={{ color: "text.secondary", display: "flex", alignItems: "center", gap: 1 }}>
      {icon} <b>{text}</b> {extra}
    </Typography>
  );

  return (
    <Card variant="outlined" sx={{ width: "50%" }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" width="100%">
          <Stack direction="row" spacing={2}>
            <Avatar alt={user?.society} src={`${server.BASE_URL}${user?.logo}`} />
            <Stack>
              <Typography sx={{ fontSize: 12 }}>{accountType}</Typography>
              <Typography gutterBottom sx={{ fontSize: 16, mb: 0 }}>
                {user?.firstname} {user?.lastname}
              </Typography>
            </Stack>
          </Stack>
          <Stack direction="row" spacing={1}>
            <IconButton color="error" onClick={openDeleteModal}>
              <DeleteIcon />
            </IconButton>
            <IconButton color="primary" onClick={openUpdateModal}>
              <EditIcon />
            </IconButton>
          </Stack>
        </Stack>
        <Divider sx={{ mt: 1, mb: 3 }} />
        <Stack spacing={2}>
          {renderDetail(<PersonIcon sx={{ fontSize: 16 }} />, user?.company_grade ?? "--")}
          {renderDetail(<LocalPhoneIcon sx={{ fontSize: 16 }} />, user?.telephone ?? "--")}
          {renderDetail(
            <EmailIcon sx={{ fontSize: 16 }} />,
            user?.email ?? "--",
            user?.isVerified ? (
              <CheckIcon sx={{ color: "success.main", width: 16 }} />
            ) : (
              <CloseIcon sx={{ color: "error.main", width: 16 }} />
            )
          )}
          {renderDetail(<LocationOnIcon sx={{ fontSize: 16 }} />, `${user?.city ?? "--"}, ${user?.country ?? "--"}`)}
        </Stack>
        <Divider sx={{ my: 2 }} />
        <Stack spacing={2}>
          {renderDetail(<AssignmentIcon sx={{ fontSize: 16 }} />, `Inscrit le : ${createdAt}`)}
          {renderDetail(<ExitToAppIcon sx={{ fontSize: 16 }} />, `Dernière connexion : ${lastLogin}`)}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default AccountDetails;
